import { render, staticRenderFns } from "./KategoriPenyaluran.vue?vue&type=template&id=840082b0"
import script from "./KategoriPenyaluran.vue?vue&type=script&lang=js"
export * from "./KategoriPenyaluran.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports